import { render, staticRenderFns } from "./ClrmParticipantsList.vue?vue&type=template&id=b29ad452&scoped=true&"
import script from "./ClrmParticipantsList.vue?vue&type=script&lang=js&"
export * from "./ClrmParticipantsList.vue?vue&type=script&lang=js&"
import style0 from "./ClrmParticipantsList.vue?vue&type=style&index=0&id=b29ad452&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b29ad452",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
installComponents(component, {VAvatar})
